"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpenTableau = void 0;
var browser_support_1 = require("@tableau/browser-support");
function OpenTableau(workbookInfo) {
    var url = CreateOpenInDesktopUrl(workbookInfo);
    if (browser_support_1.BrowserSupport.IsSafari()) {
        // Without the hidden iframe, Safari will navigate to an error page if Desktop is not installed
        var hiddenIFrame = GetOrCreateHiddenIFrame();
        hiddenIFrame.src = url;
        hiddenIFrame.id = 'tableauDesktopIFrame';
        hiddenIFrame.style.display = 'none';
        window.document.body.appendChild(hiddenIFrame);
    }
    else {
        window.open(url, '_self');
    }
}
exports.OpenTableau = OpenTableau;
function GetOrCreateHiddenIFrame() {
    var hiddenIFrame = window.document.querySelector('#tableauDesktopIFrame');
    if (hiddenIFrame) {
        return hiddenIFrame;
    }
    return window.document.createElement('iframe');
}
function CreateOpenInDesktopUrl(workbookInfo) {
    var tableauDesktopScheme = 'tableau-desktop:';
    var tableauUrl = new URL(tableauDesktopScheme);
    tableauUrl.searchParams.append('server-host', workbookInfo.serverHost);
    tableauUrl.searchParams.append('server-site-luid', workbookInfo.siteLuid);
    tableauUrl.searchParams.append('workbook-luid', workbookInfo.workbookLuid);
    tableauUrl.searchParams.append('view-luid', workbookInfo.viewLuid || '');
    return tableauUrl.href;
}
//# sourceMappingURL=ProtocolHelper.js.map